import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive } from "vue";
const _hoisted_1 = {
  class: "app-nav__inner"
};
const _hoisted_2 = {
  class: "app-nav__top-row"
};
const _hoisted_3 = {
  class: "app-nav__start"
};
const _hoisted_4 = {
  key: 0,
  class: "app-nav__search-dropdown",
  role: "listbox"
};
const _hoisted_5 = {
  class: "app-nav__search-tabs",
  role: "tablist"
};
const _hoisted_6 = ["aria-selected"];
const _hoisted_7 = {
  class: "app-nav__search-tab-count"
};
const _hoisted_8 = ["aria-selected"];
const _hoisted_9 = {
  class: "app-nav__search-tab-count"
};
const _hoisted_10 = {
  key: 0,
  class: "app-nav__search-list"
};
const _hoisted_11 = {
  key: 0,
  class: "app-nav__search-empty"
};
const _hoisted_12 = {
  key: 1,
  class: "app-nav__search-empty"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "app-nav__search-item-main"
};
const _hoisted_15 = {
  class: "app-nav__search-item-title"
};
const _hoisted_16 = {
  class: "app-nav__search-item-tags"
};
const _hoisted_17 = {
  key: 1,
  class: "app-nav__search-list"
};
const _hoisted_18 = {
  key: 0,
  class: "app-nav__search-empty"
};
const _hoisted_19 = {
  key: 1,
  class: "app-nav__search-empty"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  class: "app-nav__search-avatar",
  "aria-hidden": "true"
};
const _hoisted_22 = {
  class: "app-nav__search-item-main"
};
const _hoisted_23 = {
  class: "app-nav__search-item-title"
};
const _hoisted_24 = {
  class: "app-nav__search-meta"
};
const _hoisted_25 = {
  class: "app-nav__links",
  role: "navigation",
  "aria-label": "Primary"
};
const _hoisted_26 = {
  class: "app-nav__links-main"
};
const _hoisted_27 = ["href", "onClick"];
const _hoisted_28 = {
  class: "app-nav__link-icon",
  "aria-hidden": "true"
};
const _hoisted_29 = {
  class: "app-nav__end"
};
const _hoisted_30 = {
  key: 0,
  class: "app-nav__balances app-nav__hydrating",
  "aria-busy": "true",
  "aria-hidden": "true"
};
const _hoisted_31 = {
  key: 1,
  class: "app-nav__cta app-nav__hydrating",
  "aria-hidden": "true"
};
const _hoisted_32 = {
  class: "app-nav__how-to-play-icon",
  "aria-hidden": "true"
};
const _hoisted_33 = {
  key: 1,
  class: "app-nav__auth"
};
const _hoisted_34 = {
  key: 2,
  class: "app-nav__tools"
};
const _hoisted_35 = {
  key: 3,
  class: "app-nav__tools app-nav__tools--h5-guest"
};
const _hoisted_36 = {
  class: "app-nav__auth app-nav__auth--h5"
};
const _hoisted_37 = ["aria-label"];
const _hoisted_38 = {
  key: 0,
  class: "app-nav__balances"
};
const _hoisted_39 = {
  class: "app-nav__balance-label"
};
const _hoisted_40 = {
  class: "app-nav__balance-value"
};
const _hoisted_41 = {
  class: "app-nav__balance-label"
};
const _hoisted_42 = {
  class: "app-nav__balance-value"
};
const _hoisted_43 = {
  class: "app-nav__cta"
};
const _hoisted_44 = {
  class: "app-nav__create-market-wrap"
};
const _hoisted_45 = {
  class: "app-nav__create-market-hint",
  role: "tooltip"
};
const _hoisted_46 = {
  class: "app-nav__tools"
};
const _hoisted_47 = ["aria-label"];
const _hoisted_48 = {
  class: "app-nav__balance-chip__label"
};
const _hoisted_49 = {
  class: "app-nav__balance-chip__value"
};
const _hoisted_50 = {
  class: "app-nav__notify-wrap"
};
const _hoisted_51 = ["aria-label"];
const _hoisted_52 = ["aria-label"];
const _hoisted_53 = {
  class: "app-mobile-more-shell"
};
const _hoisted_54 = {
  class: "app-mobile-more"
};
const _hoisted_55 = {
  class: "app-mobile-more__section"
};
const _hoisted_56 = {
  class: "app-mobile-more__heading"
};
const _hoisted_57 = ["aria-label"];
const _hoisted_58 = ["onClick"];
const _hoisted_59 = {
  class: "app-mobile-more__menu-label"
};
const _hoisted_60 = {
  class: "app-mobile-more__section"
};
const _hoisted_61 = {
  class: "app-mobile-more__heading"
};
const _hoisted_62 = ["aria-label"];
const _hoisted_63 = ["href", "target", "rel", "onClick"];
const _hoisted_64 = {
  class: "app-mobile-more__menu-label"
};
const _hoisted_65 = {
  class: "app-mobile-more__support-row"
};
const _hoisted_66 = ["href"];
const _hoisted_67 = {
  class: "app-mobile-more__support-title"
};
const _hoisted_68 = {
  class: "app-mobile-more__support-meta"
};
const _hoisted_69 = ["aria-label"];
const _hoisted_70 = {
  class: "app-mobile-more__section app-mobile-more__section--locale"
};
const _hoisted_71 = {
  class: "app-mobile-more__heading"
};
const _hoisted_72 = ["aria-label"];
const _hoisted_73 = {
  class: "app-mobile-more__locale-flag",
  "aria-hidden": "true"
};
const _hoisted_74 = {
  class: "app-mobile-more__menu-label"
};
const _hoisted_75 = {
  class: "app-mobile-more__footer"
};
const _hoisted_76 = {
  class: "app-mobile-more__auth-bar"
};
const _hoisted_77 = {
  key: 0,
  class: "app-mobile-more__auth"
};
const _hoisted_78 = ["disabled", "aria-busy"];
const _hoisted_79 = {
  class: "app-mobile-more__copyright"
};
import { ref, computed, watch, onMounted, onUnmounted, defineAsyncComponent } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { onClickOutside, useMediaQuery } from '@vueuse/core';
import NotificationPanel from '@/components/NotificationPanel.vue';
import AppImage from '@/components/common/AppImage.vue';
import NavigationProgressBar from '@/components/common/NavigationProgressBar.vue';
import FloatingAssistantFab from '@/components/FloatingAssistantFab.vue';
import MobileTabBar from '@/components/MobileTabBar.vue';
import AppNavGuestMenu from '@/components/nav/AppNavGuestMenu.vue';
import AppNavUserMenu from '@/components/nav/AppNavUserMenu.vue';
import H5ChannelNav from '@/components/h5/shell/H5ChannelNav.vue';
import H5LocaleSheet from '@/components/h5/shell/H5LocaleSheet.vue';
import HomeScrollBanner from '@/components/home/HomeScrollBanner.vue';
import NavChannelIcon from '@/components/icons/NavChannelIcon.vue';
import NavAppDownloadEntry from '@/components/nav/NavAppDownloadEntry.vue';
import { NAV_CHANNEL_LINKS } from '@/constants/navChannelLinks.js';
import { useJackpotFeature } from '@/composables/useJackpotFeature.js';
import { MEDIA_MOBILE_MAX } from '@/constants/layout-breakpoints.js';
import { findLocaleOption } from '@/config/localeOptions';
import H5HowToPlayBanner from '@/components/h5/shell/H5HowToPlayBanner.vue';
import HowToPlayTour from '@/components/shell/HowToPlayTour.vue';
import TrialFundGuideHost from '@/components/trial-fund/TrialFundGuideHost.vue';
import JackpotSyncBanner from '@/components/jackpot/JackpotSyncBanner.vue';
import { Z_INDEX } from '@/config/zIndex';
import PmAlertDialog from '@/components/shell/PmAlertDialog.vue';
import { Search, Plus, Coin, Bell, ArrowRight, WalletFilled, InfoFilled, DocumentCopy } from '@element-plus/icons-vue';
import { MOBILE_MORE_LEGAL_LINKS, MOBILE_MORE_SUPPORT_EMAIL, MOBILE_MORE_SUPPORT_EXTERNAL_LINKS } from '@/config/site-footer.js';
import { AnchorHintHost, CreditClaimToastHost } from '@/components/feedback';
import { useEnableTradingPrompt } from '@/composables/useEnableTradingPrompt';
import { copyTextWithHint, hintAnchorFromEvent } from '@/utils/copy-with-hint';
import { openConfiguredLiveChat } from '@/utils/support-livechat';
import { scheduleTawkSilentPreload } from '@/utils/open-tawk-chat';
import { syncTawkVisibilityForRoute } from '@/utils/tawk-route-visibility';
import { silenceQuietShellPrompts } from '@/utils/quiet-shell-prompts';
import '@/composables/useTheme';
import { useI18n } from 'vue-i18n';
import { useAuth, setOpenLoginDialog, validateSession, promptLogin, openAuthDialog, setPendingLoginRedirect, consumePendingLoginRedirect, consumeAuthDialogOptions } from '@/composables/useAuth.js';
import { setUnauthenticatedRedirect } from '@/utils/auth-redirect';
import { useNotificationPoll } from '@/composables/useNotificationPoll.js';
import { usePortfolioBalancePoll } from '@/composables/usePortfolioBalancePoll.js';
import { useNavUserSummary } from '@/composables/useNavUserSummary.js';
import { useAuthHydration, registerAuthSoftRehydrate } from '@/composables/useAuthHydration.js';
import { switchAppLocale } from '@/locales/i18n';
import { useMarketSearch } from '@/composables/useMarketSearch.js';
import { resolveCryptoUpdownKeepAliveKey } from '@/composables/useCryptoUpdownDetailNavigation.js';
import { buildUserProfileRoute } from '@/utils/user-profile-route.js';
import { startAuthBootstrap, resetAuthBootstrapOnLogout } from '@/composables/useAuthBootstrap.js';
import { bootstrapStorageGate } from '@/composables/useStorageConsent.js';
import { initPrivy, logoutPrivyIfSession } from '@/utils/privy';
import { cancelInFlightGoogleSignIn, consumeGoogleFirebaseRedirectResult, hasPendingGoogleFirebaseRedirect } from '@/utils/firebase';
import { usePortfolioBalanceStore } from '@/stores/portfolioBalance';
import { useCustodialSessionStore } from '@/stores/custodialSession';
import { usePrivySignSessionStore } from '@/stores/privySignSession';
import { softNavigateAfterAuth } from '@/utils/auth-page-refresh';
import { navigatePostLoginOnboarding } from '@/utils/post-login-onboarding';
import { initWalletAccountSync } from '@/utils/wallet-account-sync';
import { ensureWalletConnectReady } from '@/utils/wallet-connect-session';
import { clearTokens, getWalletProviderId } from '@/utils/auth-token';
import { awaitPendingSilentCustodialBind, consumeSuppressGuestPromptAfterAuthFailure, loginGooglePlatform } from '@/utils/privy-platform-login';
import { requestTurnstileToken } from '@/utils/turnstile';
import { beginAnalyticsFlow, trackAnalyticsLog } from '@/utils/analytics-track';
import { noteAuthOpenClick } from '@/utils/analytics-conversion-extras';
import { noteAnalyticsLoginMethod } from '@/utils/analytics-acquisition';
import { consumeInviteCode, getInviteCode, storeInviteCode } from '@/utils/invite-code';
import { setDepositOpenTrigger, setOpenGlobalDepositDialog } from '@/utils/analytics-deposit-trigger';
import { chinaRegionUnsupportedOpen, dismissChinaRegionUnsupportedDialog, guardDepositAgainstChinaMainland } from '@/utils/deposit-china-guard';
import { trialActivateDepositPromptOpen, dismissTrialActivateDepositPrompt, confirmTrialActivateDepositPrompt } from '@/utils/trial-activate-deposit-guard';
import { mmWakeMatchingPromptOpen, dismissMmWakeMatchingPrompt } from '@/utils/mm-wake-matching-prompt';
import { bootstrapDepositWatchAfterLogin, resumeDepositWatch, setDepositCompleteHandler, stopDepositWatch } from '@/composables/useDepositStatus';
import { prefetchDepositSession } from '@/composables/useDepositPrefetch';
import { activeMarketDetailCollectionId } from '@/utils/market-detail-chrome.js';
import { storeToRefs } from 'pinia';
import { useRegisterRewardStore } from '@/stores/registerReward.js';
import { useTrialFundStore } from '@/stores/trialFund.js';
import { useDepositBonusPromptStore } from '@/stores/depositBonusPrompt.js';
import { preloadTrialFundAssets, TRIAL_FUND_SIM_ROUTE_NAME } from '@/constants/trial-fund.js';
import titleLogo from '@/assets/title_logo.png';
const PUBLIC_TEST_BANNER_HIDDEN_COLLECTION_ID = '322';

/** 全站展示公告条幅；仅 collectionId=322 的市场详情页隐藏 */
const chromePublicTestBannerTextKey = 'dashboard.publicTestBanner';
const showGetVantButton = false;
export default {
  __name: 'App',
  setup(__props) {
    const AuthDialog = defineAsyncComponent(() => import('@/components/AuthDialog.vue'));
    const StorageBlockedFullscreen = defineAsyncComponent(() => import('@/components/storage/StorageBlockedFullscreen.vue'));
    const DepositDialog = defineAsyncComponent(() => import('@/components/DepositDialog.vue'));
    const DepositBonusBenefitsDialog = defineAsyncComponent(() => import('@/components/deposit/DepositBonusBenefitsDialog.vue'));
    const DepositStatusEmbeddedPanel = defineAsyncComponent(() => import('@/components/DepositStatusEmbeddedPanel.vue'));
    const TradeApprovalDialog = defineAsyncComponent(() => import('@/components/TradeApprovalDialog.vue'));
    const EnableTradingDialog = defineAsyncComponent(() => import('@/components/EnableTradingDialog.vue'));
    const RegisterRewardGuestDialog = defineAsyncComponent(() => import('@/components/register/RegisterRewardGuestDialog.vue'));
    const TrialFundGuestDialog = defineAsyncComponent(() => import('@/components/trial-fund/TrialFundGuestDialog.vue'));
    const TrialFundLoggedDialog = defineAsyncComponent(() => import('@/components/trial-fund/TrialFundLoggedDialog.vue'));
    const TrialFundLoggedMini = defineAsyncComponent(() => import('@/components/trial-fund/TrialFundLoggedMini.vue'));
    const TrialFundResultDialog = defineAsyncComponent(() => import('@/components/trial-fund/TrialFundResultDialog.vue'));
    const PwaInstallBanner = defineAsyncComponent(() => import('@/components/pwa/PwaInstallBanner.vue'));
    const PortraitLockOverlay = defineAsyncComponent(() => import('@/components/common/PortraitLockOverlay.vue'));
    const router = useRouter();
    const route = useRoute();
    const {
      locale,
      t
    } = useI18n();
    const {
      isLoggedIn,
      logout,
      markLoggedIn
    } = useAuth();
    const {
      authHydrating,
      beginAuthHydration,
      endAuthHydration,
      clearAuthHydration,
      consumeSoftRedirect
    } = useAuthHydration();
    const {
      enableTradingOpen,
      enableTradingMarketKind,
      enableTradingApprovalReady,
      setEnableTradingOpen,
      completeEnableTradingPrompt
    } = useEnableTradingPrompt();
    const registerRewardStore = useRegisterRewardStore();
    const trialFundStore = useTrialFundStore();
    const depositBonusPromptStore = useDepositBonusPromptStore();
    const {
      guestModalOpen
    } = storeToRefs(registerRewardStore);
    const {
      guestModalOpen: trialGuestModalOpen,
      guestMiniOpen: trialGuestMiniOpen,
      loggedModalOpen: trialLoggedModalOpen,
      loggedMiniOpen: trialLoggedMiniOpen,
      resultOpen: trialResultOpen,
      resultKind: trialResultKind,
      resultChosenSide: trialResultChosenSide,
      dusdBalance: trialDusdBalance,
      claimLoading: trialClaimLoading,
      claimMintStatus: trialClaimMintStatus,
      surfaceHint: trialSurfaceHint,
      surfaceHintTone: trialSurfaceHintTone,
      claimNeedsDeposit: trialClaimNeedsDeposit,
      simHasPendingPosition: trialSimPending,
      hasClaimed: trialHasClaimed,
      guideActive: trialGuideActive,
      guideStep: trialGuideStep,
      guideBlocksOtherPrompts: trialGuideBlocksPrompts,
      guidePausedForResult: trialGuidePausedForResult
    } = storeToRefs(trialFundStore);
    const {
      dialogOpen: bonusBenefitsOpen,
      pendingRemind: bonusPendingRemind,
      armed: bonusArmed,
      guestArmed: guestBonusArmed,
      ladderProgressUsd: depositBonusLadderUsd,
      campaignVisible: depositBonusCampaignVisible
    } = storeToRefs(depositBonusPromptStore);

    /** 引导屏蔽期间隐藏客服浮标；到「客服」步再露出供框选 */
    const showFloatingAssistantDuringGuide = computed(() => {
      if (!trialGuideBlocksPrompts.value) return true;
      return trialGuideActive.value && trialGuideStep.value === 'kefu';
    });
    const {
      hasUnread,
      refreshUnreadCounts
    } = useNotificationPoll();
    usePortfolioBalancePoll();
    const {
      profile: navProfile,
      totalAssetsLabel: navTotalAssetsLabel,
      walletBalanceLabel: navWalletBalanceLabel,
      profileLoading: navProfileLoading,
      refresh: refreshNavSummary
    } = useNavUserSummary();
    const isMobileNav = useMediaQuery(MEDIA_MOBILE_MAX);
    const {
      enabled: jackpotFeatureEnabled
    } = useJackpotFeature();
    const navChannelLinks = computed(() => NAV_CHANNEL_LINKS.filter(item => item.feature !== 'jackpot' || jackpotFeatureEnabled.value));
    function keepAliveViewKey(viewRoute) {
      const name = String(viewRoute?.name ?? '');
      if (name === 'CryptoUpdownDetail') {
        return resolveCryptoUpdownKeepAliveKey(viewRoute);
      }
      return viewRoute?.name;
    }

    /** H5 顶栏单行 + 频道横滑（探索→推荐，见 H5ChannelNav） */
    const hideMobileNavLinks = computed(() => isMobileNav.value);
    const showH5ChannelNav = computed(() => isMobileNav.value && !isFullscreenRoute.value);
    const showChromePublicTestBanner = computed(() => {
      if (isFullscreenRoute.value) return false;
      if (activeMarketDetailCollectionId.value === PUBLIC_TEST_BANNER_HIDDEN_COLLECTION_ID) {
        return false;
      }
      return true;
    });
    const showGuestMobileTab = computed(() => !isLoggedIn.value && isMobileNav.value && !isFullscreenRoute.value);

    /** 暂时隐藏导航栏「获取 Vant」按钮 */
    const searchQuery = ref('');
    const navSearchOpen = ref(false);
    const navSearchWrapRef = ref(null);
    const searchTab = ref('market');
    const trimmedSearch = computed(() => searchQuery.value.trim());
    const isFullscreenRoute = computed(() => Boolean(route.meta?.fullscreen));
    /** /pwa 拉新页等：不展示全站 PWA 安装条 */
    const hidePwaBanner = computed(() => Boolean(route.meta?.hidePwaBanner));
    /** /pwa 拉新页：屏蔽全站营销弹窗 / 引导条 */
    const isQuietShellRoute = computed(() => Boolean(route.meta?.quietShell));
    const isBonusPromptBlocked = computed(() => {
      if (isQuietShellRoute.value || !isLoggedIn.value) return true;
      if (authDialogVisible.value) return true;
      if (showDeposit.value) return true;
      if (trialGuideBlocksPrompts.value) return true;
      if (trialLoggedModalOpen.value) return true;
      if (route.name === TRIAL_FUND_SIM_ROUTE_NAME) return true;
      return false;
    });
    const isGuestBonusPromptBlocked = computed(() => {
      if (isQuietShellRoute.value || isLoggedIn.value) return true;
      if (authDialogVisible.value || showDeposit.value) return true;
      if (trialGuideBlocksPrompts.value) return true;
      if (guestModalOpen.value || trialGuestModalOpen.value || trialLoggedModalOpen.value) return true;
      if (route.name === TRIAL_FUND_SIM_ROUTE_NAME) return true;
      return false;
    });
    /** PC：FeedScrollRoot 页才锁视口高度，其余页保持 document 滚动 */
    const isFeedScrollRoute = computed(() => Boolean(route.meta?.feedScroll));
    const navSearchEnabled = computed(() => navSearchOpen.value && Boolean(trimmedSearch.value));
    const {
      markets: searchMarkets,
      users: searchUsers,
      loading: searchLoading
    } = useMarketSearch(trimmedSearch, {
      debounceMs: 300,
      enabled: navSearchEnabled
    });
    const searchMarketResults = computed(() => searchMarkets.value);
    const searchPersonalResults = computed(() => searchUsers.value);
    function formatCount(n) {
      if (n >= 10000) return `${(n / 1000).toFixed(1)}K`;
      if (n >= 1000) return n.toLocaleString();
      return String(n);
    }
    function onSelectMarketResult(item) {
      closeNavSearch();
      searchQuery.value = '';
      router.push(item.route);
    }
    function onSelectPersonaResult(item) {
      closeNavSearch();
      searchQuery.value = '';
      const to = buildUserProfileRoute({
        userId: item.id,
        from: 'search'
      });
      if (to) router.push(to);
    }
    const notifyOpen = ref(false);
    const notifyWrapRef = ref(null);
    const authDialogVisible = ref(false);
    /** App 正在消费 Google Redirect token：驱动 AuthDialog 转圈页，不是整页遮罩 */
    const googleRedirectCompleting = ref(false);
    /** Redirect 已拿到 token，正在换平台 Session */
    const googleRedirectSigningIn = ref(false);
    const authInitialTab = ref('login');
    const authDialogHideWallets = ref(false);
    const authDialogContextKey = ref('');
    const showDeposit = ref(false);

    // 允许充值弹窗与充值福利弹窗同时打开与叠加
    const mobileMenuOpen = ref(false);
    const localeSheetOpen = ref(false);
    const howToPlayOpen = ref(false);
    watch(isQuietShellRoute, quiet => {
      if (!quiet) return;
      authDialogVisible.value = false;
      showDeposit.value = false;
      howToPlayOpen.value = false;
      silenceQuietShellPrompts();
    }, {
      immediate: true
    });
    watch([isBonusPromptBlocked, bonusPendingRemind, bonusArmed], ([blocked]) => {
      if (!blocked) depositBonusPromptStore.tryShow();
    }, {
      flush: 'post'
    });
    watch([isGuestBonusPromptBlocked, guestBonusArmed], ([blocked]) => {
      depositBonusPromptStore.tryShowGuest({
        blocked
      });
    }, {
      flush: 'post'
    });
    const mobileMoreLegalLinks = MOBILE_MORE_LEGAL_LINKS;
    const mobileMoreSupportEmail = MOBILE_MORE_SUPPORT_EMAIL;
    const mobileMoreSupportExternalLinks = MOBILE_MORE_SUPPORT_EXTERNAL_LINKS;
    const mobileMoreCopyrightYear = new Date().getFullYear();
    const mobileMoreLocaleOption = computed(() => findLocaleOption(locale.value));
    const isProfileRouteActive = computed(() => {
      const path = String(route.path || '');
      return path === '/account' || path.startsWith('/account/');
    });

    /** 头像 / 底栏「我的」：未登录弹登录；已登录进个人中心 */
    function onH5AvatarOrMineClick() {
      goAccount();
    }

    /** 客服：打开「更多」侧栏 */
    function openCustomerService() {
      mobileMenuOpen.value = true;
    }
    function onHowToPlayGetStarted() {
      if (!isLoggedIn.value) openLoginDialog();
    }
    watch(isLoggedIn, loggedIn => {
      // 登录成功后关掉导览即可；底栏玩法介绍条登录后仍保留（可关掉）
      if (loggedIn) howToPlayOpen.value = false;
    });
    function closeNavSearch() {
      navSearchOpen.value = false;
    }
    function onMobileMoreNav(path) {
      mobileMenuOpen.value = false;
      closeNavSearch();
      if (route.path !== path) {
        router.push(path);
      }
    }
    function onMobileMoreSupportClick() {
      mobileMenuOpen.value = false;
      closeNavSearch();
    }
    function onMobileMoreExternalSupportClick(event, link) {
      if (link?.openTawk || link?.openLiveChat) {
        event.preventDefault();
        void openConfiguredLiveChat({
          source: 'mobile_more'
        });
      }
      onMobileMoreSupportClick();
    }
    function onMobileMoreSwitchLocale(code) {
      localeSheetOpen.value = false;
      mobileMenuOpen.value = false;
      closeNavSearch();
      void switchLocale(code);
    }
    function openMobileMoreLocale() {
      mobileMenuOpen.value = false;
      closeNavSearch();
      localeSheetOpen.value = true;
    }
    async function copyMobileMoreEmail(event) {
      const value = String(mobileMoreSupportEmail.address ?? '').trim();
      if (!value) return;
      await copyTextWithHint({
        text: value,
        anchor: hintAnchorFromEvent(event),
        successText: t('referralPage.code.copied'),
        failText: t('referralPage.copyFail')
      });
    }
    function openMobileMoreLogin() {
      mobileMenuOpen.value = false;
      closeNavSearch();
      openLoginDialog();
    }
    function openMobileMoreRegister() {
      mobileMenuOpen.value = false;
      closeNavSearch();
      openRegisterDialog();
    }
    onClickOutside(notifyWrapRef, () => {
      notifyOpen.value = false;
    });
    onClickOutside(navSearchWrapRef, () => {
      if (navSearchOpen.value) closeNavSearch();
    });
    let removeNavSearchEscape = null;
    watch(navSearchOpen, open => {
      removeNavSearchEscape?.();
      removeNavSearchEscape = null;
      if (open) {
        trackAnalyticsLog({
          key: 'nav.search_open',
          label: '打开导航搜索',
          value: {}
        });
      }
      if (!open) return;
      const onKey = e => {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeNavSearch();
        }
      };
      document.addEventListener('keydown', onKey, true);
      removeNavSearchEscape = () => document.removeEventListener('keydown', onKey, true);
    });
    function ensureCustodialAndSignSession(opts = {}) {
      const custodial = useCustodialSessionStore().ensureIfNeeded(opts);
      const sign = opts.foreground ? usePrivySignSessionStore().ensureOnForeground() : usePrivySignSessionStore().ensureIfNeeded({
        force: Boolean(opts.force)
      });
      return Promise.all([custodial, sign]);
    }
    function onAppActivate() {
      if (document.visibilityState === 'visible') {
        validateSession();
        if (isLoggedIn.value) {
          void ensureCustodialAndSignSession({
            foreground: true
          });
        }
      }
    }
    function onWindowFocus() {
      validateSession();
      if (isLoggedIn.value) {
        void ensureCustodialAndSignSession({
          foreground: true
        });
      }
    }
    async function completeGoogleFirebaseRedirect() {
      const redirected = await consumeGoogleFirebaseRedirectResult();
      // 用户已主动打开登录窗（邮箱/钱包）时，以其当前选择为准，不让迟到的 Google 回调覆盖。
      if (!redirected?.googleToken || isLoggedIn.value) return false;
      if (authDialogVisible.value && !googleRedirectCompleting.value) return false;
      googleRedirectCompleting.value = true;
      if (!isQuietShellRoute.value && !authDialogVisible.value) {
        openAuthDialog({
          source: 'google_redirect'
        });
      }
      noteAnalyticsLoginMethod('GOOGLE');
      const inviteCode = redirected.inviteCode || getInviteCode() || undefined;
      if (inviteCode) storeInviteCode(inviteCode);
      await logoutPrivyIfSession();
      if (isLoggedIn.value || authDialogVisible.value && !googleRedirectCompleting.value) {
        return false;
      }
      clearTokens();
      googleRedirectSigningIn.value = true;
      // Soft-fail: backend only requires captcha for NEW Google accounts. Returning users
      // must still reach loginGooglePlatform if Turnstile CDN/widget is down.
      const captchaToken = await requestTurnstileToken('login_google').catch(err => {
        console.warn('[auth] turnstile google redirect failed; continue without token', err);
        return '';
      });
      const serverTicket = String(redirected.serverTicket || '').trim() || undefined;
      let pow = redirected.pow || undefined;
      if (pow?.serverTicket) {
        const {
          serverTicket: _st,
          ...powOnly
        } = pow;
        pow = powOnly;
      }
      const {
        email
      } = await loginGooglePlatform({
        googleToken: redirected.googleToken,
        email: redirected.email,
        inviteCode,
        captchaToken,
        serverTicket,
        pow
      });
      // 托管 Privy 绑定延后到首次充值成功（scheduleSilentPrivyBindAfterFirstDeposit）
      consumeInviteCode();
      beginAuthHydration(consumePendingLoginRedirect());
      const ok = markLoggedIn();
      authDialogVisible.value = false;
      if (!ok) clearAuthHydration();
      return ok;
    }
    onMounted(() => {
      syncTawkVisibilityForRoute(route);
      // 非 quietShell：站点就绪后空闲静默预载 Tawk，避免点客服再注入偏慢
      if (!isQuietShellRoute.value) {
        scheduleTawkSilentPreload();
      }
      setUnauthenticatedRedirect(() => {
        if (route.meta?.requiresAuth && route.name !== 'Home') {
          void router.replace({
            name: 'Home'
          });
        }
      });
      setOpenGlobalDepositDialog(openDeposit);
      setOpenLoginDialog(openLoginDialog);
      registerAuthSoftRehydrate(async () => {
        await refreshNavSummary(true, true);
        void refreshUnreadCounts();
        void ensureCustodialAndSignSession({
          force: true
        });
        void prefetchDepositSession();
      });
      if (!isQuietShellRoute.value) {
        bootstrapStorageGate();
      }
      initWalletAccountSync();
      if (isLoggedIn.value && getWalletProviderId() === 'walletconnect') {
        ensureWalletConnectReady().catch(err => {
          console.warn('[wallet-connect] session restore failed', err);
        });
      }
      setDepositCompleteHandler(() => {
        void usePortfolioBalanceStore().refreshAfterTrade();
      });
      if (isLoggedIn.value) {
        resumeDepositWatch();
      }
      validateSession();
      if (!isLoggedIn.value) {
        // Redirect token 必须在 App 启动时立刻消费；转圈交给登录弹窗，不要整页遮罩。
        const pendingGoogleRedirect = hasPendingGoogleFirebaseRedirect();
        if (pendingGoogleRedirect) {
          googleRedirectCompleting.value = true;
          if (!isQuietShellRoute.value) {
            openAuthDialog({
              source: 'google_redirect'
            });
          }
        }
        const redirectDone = completeGoogleFirebaseRedirect().catch(err => {
          console.error('[auth] Google redirect -> platform login failed', err);
          clearAuthHydration();
          if (!isLoggedIn.value && !isQuietShellRoute.value) {
            openAuthDialog({
              contextKey: 'authDialog.loginFailed',
              source: 'google_redirect_error'
            });
          }
        }).finally(() => {
          googleRedirectCompleting.value = false;
          googleRedirectSigningIn.value = false;
        });
        if (pendingGoogleRedirect) {
          void redirectDone.finally(() => {
            if (!isLoggedIn.value && !isQuietShellRoute.value && !authDialogVisible.value) {
              registerRewardStore.tryOpenGuestPrompt({
                routePath: route.path,
                fullscreenRoute: isFullscreenRoute.value
              });
            }
          });
        }
      }
      preloadTrialFundAssets();
      if (!isQuietShellRoute.value) {
        if (isLoggedIn.value) {
          // 登录后只走新福利盘大窗 / FC，不再弹旧「恭喜你领取 DScoin」窗
          void trialFundStore.tryOpenLoggedPrompt();
        } else if (!hasPendingGoogleFirebaseRedirect() && !googleRedirectCompleting.value) {
          // 暂不弹试玩金未登录引导，直接走新注册奖励 guest 窗
          registerRewardStore.tryOpenGuestPrompt({
            routePath: route.path,
            fullscreenRoute: isFullscreenRoute.value
          });
        }
      }
      if (isLoggedIn.value) {
        // 已登录冷启动：即使 initPrivy 失败也要跑托管兜底（回填 / 静默重授权）
        void ensureCustodialAndSignSession({
          force: true
        });
        initPrivy().then(async () => {
          // 托管会话：initPrivy；自管会话：trade-address 已在登录时登记
          await refreshNavSummary(true, true);
          await bootstrapDepositWatchAfterLogin();
          void ensureCustodialAndSignSession({
            force: true
          });
          void prefetchDepositSession();
        }).catch(error => {
          console.warn('[privy] init failed', error);
          void ensureCustodialAndSignSession({
            force: true
          });
        });
      } else {
        startAuthBootstrap().catch(error => {
          console.warn('[auth-bootstrap] privy warmup failed', error);
        });
      }
      document.addEventListener('visibilitychange', onAppActivate);
      window.addEventListener('focus', onWindowFocus);
    });
    watch(isLoggedIn, async loggedIn => {
      cancelInFlightGoogleSignIn();
      if (!loggedIn) {
        clearAuthHydration();
        stopDepositWatch();
        notifyOpen.value = false;
        showDeposit.value = false;
        registerRewardStore.resetOnLogout();
        trialFundStore.resetOnLogout();
        depositBonusPromptStore.resetOnLogout();
        useCustodialSessionStore().reset();
        usePrivySignSessionStore().reset();
        resetAuthBootstrapOnLogout();
        void startAuthBootstrap();
        // 静默 bind 失败会立刻再开登录窗：勿与游客福利窗叠弹
        if (!isQuietShellRoute.value && !consumeSuppressGuestPromptAfterAuthFailure()) {
          // 暂不弹试玩金未登录引导，直接走注册奖励
          // trialFundStore.tryOpenGuestPrompt({
          //   routePath: route.path,
          //   fullscreenRoute: isFullscreenRoute.value,
          // });
          registerRewardStore.tryOpenGuestPrompt({
            routePath: route.path,
            fullscreenRoute: isFullscreenRoute.value
          });
        }
        return;
      }
      registerRewardStore.closeGuestPromptForLogin();
      trialFundStore.dismissGuestPrompt();
      if (getWalletProviderId() === 'walletconnect') {
        ensureWalletConnectReady().catch(err => {
          console.warn('[wallet-connect] session restore after login failed', err);
        });
      }
      try {
        try {
          await refreshNavSummary(true, true);
        } catch (err) {
          console.warn('[auth] refreshNavSummary after login failed', err);
        }

        // 邮箱/Google：等静默托管 bind；随后 ensure（含失败重试）供充提弹窗就绪 + 签名会话
        await awaitPendingSilentCustodialBind();
        if (!isLoggedIn.value) {
          return;
        }
        void ensureCustodialAndSignSession({
          force: true
        });

        // 待领种子积分：登录后静默查 status，有 pending 再拉签名领取（无钱包则跳过）
        void import('@/api/welcome-pack').then(({
          claimPendingWelcomePackIfAny
        }) => claimPendingWelcomePackIfAny()).then(res => {
          if (res?.grantedKinds?.length) {
            void refreshNavSummary(true, true);
          }
        }).catch(err => {
          console.warn('[welcome-pack] post-login claim skipped', err);
        });

        // 先分流跳转，再决定是否弹福利窗（进 1+1 模拟盘时不再叠大窗）
        let onboardingKind = 'skip';
        try {
          onboardingKind = await navigatePostLoginOnboarding(router, consumeSoftRedirect(), {
            quietShell: isQuietShellRoute.value
          });
        } catch (err) {
          console.warn('[auth] post-login onboarding failed', err);
        }
        if (!isQuietShellRoute.value && onboardingKind !== 'trialSim') {
          await trialFundStore.tryOpenLoggedPrompt();
        }
        const depositBonusEligible = await depositBonusPromptStore.ensureEligibility(trialFundStore.conditions);
        if (!isLoggedIn.value) return;
        if (depositBonusEligible) depositBonusPromptStore.armAfterLogin();
        await initPrivy();
        await bootstrapDepositWatchAfterLogin();
        void prefetchDepositSession();
        void refreshUnreadCounts();
      } catch (err) {
        console.warn('[auth] soft bootstrap after login failed', err);
      } finally {
        endAuthHydration();
      }
    });
    watch(() => route.path, () => {
      mobileMenuOpen.value = false;
      syncTawkVisibilityForRoute(route);
      if (!isQuietShellRoute.value) {
        scheduleTawkSilentPreload();
      }
    });
    function onSearch() {
      const q = trimmedSearch.value;
      if (!q) return;
      trackAnalyticsLog({
        key: 'search.submit',
        label: '提交搜索',
        value: {
          q,
          tab: searchTab.value === 'personal' ? 'personal' : 'market'
        }
      });
      closeNavSearch();
      router.push({
        name: 'Search',
        query: {
          q,
          ...(searchTab.value === 'personal' ? {
            type: 'personal'
          } : {})
        }
      });
    }
    watch(trimmedSearch, (v, prev) => {
      if (!prev && v) searchTab.value = 'market';
    });
    function onNavLogoClick() {
      trackAnalyticsLog({
        key: 'nav.logo_click',
        label: '点击Logo',
        value: {}
      });
    }
    function goCreateMarket() {
      if (!promptLogin('/create-market')) return;
      trackAnalyticsLog({
        key: 'nav.create_click',
        label: '点击创建入口',
        value: {
          source: 'nav'
        }
      });
      trackAnalyticsLog({
        key: 'create_market.open',
        label: '打开创建市场',
        value: {
          source: 'nav'
        }
      });
      router.push('/create-market');
    }
    function onNavChannelClick(item, navigate, event) {
      const channel = String(item?.key || '').trim();
      if (channel) {
        trackAnalyticsLog({
          key: 'channel.switch',
          label: '频道切换',
          value: {
            channel,
            source: 'pc'
          }
        });
      }
      navigate(event);
    }
    function goGetVant() {
      router.push('/get-vant');
    }

    /**
     * 打开 App 壳 DepositDialog（顶栏 / 快捷下单 / 交易表单共用）
     * @param {{ trigger?: string }} [opts]
     * @returns {Promise<boolean>}
     */
    function onChinaRegionUnsupportedVisible(open) {
      if (open) {
        chinaRegionUnsupportedOpen.value = true;
        return;
      }
      dismissChinaRegionUnsupportedDialog();
    }
    function onTrialActivateDepositVisible(open) {
      if (open) {
        trialActivateDepositPromptOpen.value = true;
        return;
      }
      dismissTrialActivateDepositPrompt();
    }
    async function onTrialActivateDepositConfirm() {
      await confirmTrialActivateDepositPrompt();
    }
    function onMmWakeMatchingVisible(open) {
      if (open) {
        mmWakeMatchingPromptOpen.value = true;
        return;
      }
      dismissMmWakeMatchingPrompt();
    }
    function onMmWakeMatchingConfirm() {
      dismissMmWakeMatchingPrompt();
    }
    async function openDeposit(opts = {}) {
      if (!promptLogin()) return false;
      const allowed = await guardDepositAgainstChinaMainland();
      if (!allowed) return false;
      setDepositOpenTrigger(opts?.trigger || 'nav');
      showDeposit.value = true;
      return true;
    }
    function onBonusBenefitsVisible(open) {
      if (open) {
        depositBonusPromptStore.openManual();
        return;
      }
      depositBonusPromptStore.dismiss();
    }
    async function onBonusBenefitsConfirm(usd) {
      const n = Number(usd);
      if (Number.isFinite(n) && n > 0) {
        depositBonusPromptStore.setLadderPreviewUsd(n);
        try {
          const {
            useMixPayDepositStore
          } = await import('@/stores/mixPayDeposit');
          useMixPayDepositStore().setAmount(String(n));
        } catch {
          /* ignore */
        }
      }
      depositBonusPromptStore.closeBeforeDeposit();
      if (showDeposit.value) return;
      await openDeposit({
        trigger: 'deposit_bonus'
      });
    }
    async function goAccount() {
      if (!promptLogin()) return;
      router.push('/account');
    }
    function goNotifications() {
      closeNavSearch();
      notifyOpen.value = false;
      router.push('/notifications');
    }
    const loggingOut = ref(false);
    async function onNavLogout() {
      if (loggingOut.value) return;
      loggingOut.value = true;
      const leaveAuthRoute = Boolean(route.meta?.requiresAuth);
      try {
        // logoutApi + Privy logout 在 useAuth.logout 内静默调用；本地 teardown 清缓存，不整页刷新
        await logout();
        if (leaveAuthRoute && route.name !== 'Home') {
          softNavigateAfterAuth(router, '/');
        }
      } catch (err) {
        console.warn('[auth] logout failed', err);
      } finally {
        loggingOut.value = false;
      }
    }
    async function onMobileMoreLogout() {
      mobileMenuOpen.value = false;
      await onNavLogout();
    }
    function onRegisterRewardGuestMinimize() {
      registerRewardStore.minimizeGuestPrompt();
      // 关大窗 → 右侧 FC 小浮窗（与试玩金 guest mini 同源）
      trialFundStore.closeGuestPrompt();
      depositBonusPromptStore.armGuestAfterRegisterRewardDismiss();
    }
    function onRegisterRewardGuestLogin() {
      registerRewardStore.closeGuestPromptForLogin();
      // 进登录：记下 mini，但 AuthDialog 打开期间不展示 FC（见 TrialFundLoggedMini 绑定）
      trialFundStore.closeGuestPromptForLogin();
      openAuthDialog({
        contextKey: 'registerReward.guestAuthContext',
        source: 'register'
      });
    }
    function onNotifyToggle() {
      notifyOpen.value = !notifyOpen.value;
      if (notifyOpen.value) {
        trackAnalyticsLog({
          key: 'notification.open',
          label: '打开通知面板',
          value: {}
        });
      }
    }
    function onTrialFundGuestLogin() {
      trialFundStore.closeGuestPromptForLogin();
      openAuthDialog({
        contextKey: 'trialFund.guestAuthContext',
        source: 'register'
      });
    }
    function onTrialFundGuestLater() {
      trackAnalyticsLog({
        key: 'trial_fund.later',
        label: '试用金稍后再说',
        value: {
          audience: 'guest'
        }
      });
      trialFundStore.closeGuestPrompt();
    }
    async function onTrialResultDeposit() {
      await openDeposit({
        trigger: 'trial_fund_claim'
      });
    }

    /** 可先玩模拟盘；领取须真实充值（EOA/邮箱同闸），充值后自动再领 */
    async function onTrialFundGoClaim() {
      trialFundStore.closeLoggedPrompt({
        showFeedCard: true
      });
      await router.push({
        name: TRIAL_FUND_SIM_ROUTE_NAME
      });
    }
    function onTrialFundViewDscoin() {
      trialFundStore.closeLoggedPrompt({
        showFeedCard: true
      });
      router.push({
        name: 'AccountPoints'
      });
    }
    function onTrialFundLoggedLater() {
      trackAnalyticsLog({
        key: 'trial_fund.later',
        label: '试用金稍后再说',
        value: {
          audience: 'logged'
        }
      });
      trialFundStore.closeLoggedPrompt({
        showFeedCard: true
      });
    }
    function onTrialFundMiniExpand() {
      if (isLoggedIn.value && trialSimPending.value) {
        router.push({
          name: TRIAL_FUND_SIM_ROUTE_NAME
        });
        return;
      }
      // 未领体验金：悬浮球直接进模拟盘（与「刚注册就有体验盘口」一致）
      if (isLoggedIn.value && !trialFundStore.hasClaimed) {
        trialFundStore.closeLoggedPrompt({
          showFeedCard: true
        });
        router.push({
          name: TRIAL_FUND_SIM_ROUTE_NAME
        });
        return;
      }
      if (isLoggedIn.value) {
        trialFundStore.expandLoggedPrompt();
        return;
      }
      trialFundStore.expandGuestPrompt();
    }
    function onTrialResultVisible(next) {
      if (!next) {
        trialFundStore.closeResultDialog();
        trialFundStore.acknowledgeSimResult();
        if (trialFundStore.guidePausedForResult) {
          trialFundStore.resumeGuideAtKefuAfterWin();
        }
      }
    }
    function onTrialResultViewBalance() {
      trialFundStore.closeResultDialog();
      trialFundStore.acknowledgeSimResult();
      // Navigate first so kefu anchors settle on Account, then resume guide.
      void router.push({
        name: 'Account'
      }).then(() => {
        if (trialFundStore.guidePausedForResult) {
          trialFundStore.resumeGuideAtKefuAfterWin();
        }
      });
    }
    function onTrialResultContinue() {
      trialFundStore.closeResultDialog();
      trialFundStore.acknowledgeSimResult();
      void router.push({
        name: 'Home'
      }).then(() => {
        if (trialFundStore.guidePausedForResult) {
          trialFundStore.resumeGuideAtKefuAfterWin();
        }
      });
    }
    function onTrialResultRetry() {
      const wasPaused = trialFundStore.guidePausedForResult;
      // 先 resume 清 pause，再关窗，避免 update:model-value 误走 finishGuide
      if (wasPaused) {
        trialFundStore.resumeGuideAfterLoseRetry();
      }
      trialFundStore.closeResultDialog();
      trialFundStore.acknowledgeSimResult();
      if (wasPaused) {
        // 含「首页开奖」步输掉：进福利盘详情继续竞猜引导
        void router.push({
          name: TRIAL_FUND_SIM_ROUTE_NAME
        });
        return;
      }
      if (trialHasClaimed.value) return;
      void router.push({
        name: TRIAL_FUND_SIM_ROUTE_NAME
      });
    }
    function openRegisterDialog() {
      openAuthDialog({
        source: 'register'
      });
    }
    function openLoginDialog() {
      const opts = consumeAuthDialogOptions();
      noteAuthOpenClick();
      authDialogHideWallets.value = Boolean(opts.hideWalletOptions);
      authDialogContextKey.value = String(opts.contextKey ?? '').trim();
      // 显式回跳（如创建市场）优先；否则每次打开都刷新为当前页，避免旧 `/` 把详情踢回首页
      const sticky = String(opts.redirectAfterLogin ?? '').trim();
      if (sticky) {
        setPendingLoginRedirect(sticky);
      } else {
        setPendingLoginRedirect(route.fullPath);
      }
      authInitialTab.value = 'login';
      beginAnalyticsFlow('login');
      const openSource = String(opts.source ?? '').trim() || 'active';
      const contextKey = authDialogContextKey.value || undefined;
      const isRegisterIntent = openSource === 'register' || contextKey === 'registerReward.guestAuthContext' || contextKey === 'trialFund.guestAuthContext';
      if (isRegisterIntent) {
        trackAnalyticsLog({
          key: 'register.open',
          label: '注册打开',
          value: {
            source: openSource === 'register' ? 'register' : openSource,
            contextKey
          }
        });
      }
      trackAnalyticsLog({
        key: 'login.open',
        label: '打开登录',
        value: {
          contextKey,
          hideWalletOptions: authDialogHideWallets.value || undefined,
          source: openSource
        }
      });
      authDialogVisible.value = true;
    }
    watch(authDialogVisible, open => {
      if (open) return;
      authDialogHideWallets.value = false;
      authDialogContextKey.value = '';
      // 福利盘下单唤起登录关闭后：恢复暂关的引导
      trialFundStore.resumeGuideAfterAuth();
    });

    /** 引导进行中：关掉已打开的自动营销弹窗，避免与引导叠层 */
    watch(trialGuideBlocksPrompts, blocked => {
      if (!blocked) return;
      registerRewardStore.resetGuestPrompt();
      howToPlayOpen.value = false;
      if (enableTradingOpen.value) setEnableTradingOpen(false);
      // 结果窗在 guidePausedForResult 时是主动弹出的，不要关
      if (trialResultOpen.value && !trialFundStore.guidePausedForResult) {
        trialFundStore.closeResultDialog();
      }
      // 登录窗由用户手动触发，不关
    });
    onUnmounted(() => {
      setOpenGlobalDepositDialog(null);
      depositBonusPromptStore.stopRemind();
      removeNavSearchEscape?.();
      document.removeEventListener('visibilitychange', onAppActivate);
      window.removeEventListener('focus', onWindowFocus);
    });
    async function switchLocale(code) {
      if (locale.value === code) return;
      await switchAppLocale(code);
    }
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_badge = _resolveComponent("el-badge");
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_drawer = _resolveComponent("el-drawer");
      return _openBlock(), _createElementBlock("div", {
        id: "app",
        class: _normalizeClass({
          'is-fullscreen-route': isFullscreenRoute.value,
          'is-feed-scroll-route': isFeedScrollRoute.value,
          'is-nav-compact': hideMobileNavLinks.value,
          'has-h5-channel-nav': showH5ChannelNav.value,
          'has-chrome-banner': showChromePublicTestBanner.value,
          'is-guest-mobile-tab': showGuestMobileTab.value
        })
      }, [_createVNode(NavigationProgressBar), !isFullscreenRoute.value ? (_openBlock(), _createElementBlock("nav", {
        key: 0,
        class: _normalizeClass(["app-nav", {
          'app-nav--compact': hideMobileNavLinks.value
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
        to: "/",
        class: "app-nav__brand",
        "aria-label": "DeepSage",
        onClick: onNavLogoClick
      }, {
        default: _withCtx(() => [_createVNode(AppImage, {
          src: _unref(titleLogo),
          alt: "DeepSage",
          eager: ""
        }, null, 8, ["src"])]),
        _: 1
      })]), _createElementVNode("div", {
        ref_key: "navSearchWrapRef",
        ref: navSearchWrapRef,
        class: "app-nav__search"
      }, [_createVNode(_component_el_input, {
        modelValue: searchQuery.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchQuery.value = $event),
        class: "app-nav__search-input",
        placeholder: _ctx.$t('nav.search'),
        "prefix-icon": _unref(Search),
        clearable: "",
        onFocus: _cache[1] || (_cache[1] = $event => navSearchOpen.value = true),
        onKeyup: _withKeys(onSearch, ["enter"])
      }, null, 8, ["modelValue", "placeholder", "prefix-icon"]), navSearchOpen.value && trimmedSearch.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("button", {
        type: "button",
        role: "tab",
        class: _normalizeClass(["app-nav__search-tab", {
          'is-active': searchTab.value === 'market'
        }]),
        "aria-selected": searchTab.value === 'market',
        onClick: _cache[2] || (_cache[2] = $event => searchTab.value = 'market')
      }, [_createTextVNode(_toDisplayString(_ctx.$t('nav.searchTabMarket')) + " ", 1), _createElementVNode("span", _hoisted_7, _toDisplayString(searchMarketResults.value.length), 1)], 10, _hoisted_6), _createElementVNode("button", {
        type: "button",
        role: "tab",
        class: _normalizeClass(["app-nav__search-tab", {
          'is-active': searchTab.value === 'personal'
        }]),
        "aria-selected": searchTab.value === 'personal',
        onClick: _cache[3] || (_cache[3] = $event => searchTab.value = 'personal')
      }, [_createTextVNode(_toDisplayString(_ctx.$t('nav.searchTabPersonal')) + " ", 1), _createElementVNode("span", _hoisted_9, _toDisplayString(searchPersonalResults.value.length), 1)], 10, _hoisted_8)]), searchTab.value === 'market' ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [_unref(searchLoading) ? (_openBlock(), _createElementBlock("li", _hoisted_11, _toDisplayString(_ctx.$t('markets.loadingMore')), 1)) : !searchMarketResults.value.length ? (_openBlock(), _createElementBlock("li", _hoisted_12, _toDisplayString(_ctx.$t('nav.searchEmpty')), 1)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchMarketResults.value, m => {
        return _openBlock(), _createElementBlock("li", {
          key: m.id
        }, [_createElementVNode("button", {
          type: "button",
          class: "app-nav__search-item",
          onClick: $event => onSelectMarketResult(m)
        }, [_createElementVNode("span", {
          class: "app-nav__search-thumb",
          style: _normalizeStyle(m.imageUrl ? undefined : {
            background: m.accent
          }),
          "aria-hidden": "true"
        }, [m.imageUrl ? (_openBlock(), _createBlock(AppImage, {
          key: 0,
          src: m.imageUrl,
          alt: "",
          class: "app-nav__search-thumb-img"
        }, null, 8, ["src"])) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(_toDisplayString(m.initial), 1)], 64))], 4), _createElementVNode("span", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(m.title), 1), _createElementVNode("span", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.tags, tag => {
          return _openBlock(), _createElementBlock("span", {
            key: tag.key,
            class: _normalizeClass(["app-nav__search-tag", `app-nav__search-tag--${tag.tone}`])
          }, _toDisplayString(tag.label), 3);
        }), 128))])]), _createVNode(_component_el_icon, {
          class: "app-nav__search-item-arrow"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowRight))]),
          _: 1
        })], 8, _hoisted_13)]);
      }), 128))])) : (_openBlock(), _createElementBlock("ul", _hoisted_17, [_unref(searchLoading) ? (_openBlock(), _createElementBlock("li", _hoisted_18, _toDisplayString(_ctx.$t('markets.loadingMore')), 1)) : !searchPersonalResults.value.length ? (_openBlock(), _createElementBlock("li", _hoisted_19, _toDisplayString(_ctx.$t('nav.searchEmpty')), 1)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchPersonalResults.value, p => {
        return _openBlock(), _createElementBlock("li", {
          key: p.id
        }, [_createElementVNode("button", {
          type: "button",
          class: "app-nav__search-item",
          onClick: $event => onSelectPersonaResult(p)
        }, [_createElementVNode("span", _hoisted_21, _toDisplayString(p.initial), 1), _createElementVNode("span", _hoisted_22, [_createElementVNode("span", _hoisted_23, _toDisplayString(p.name), 1), _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('nav.searchFollowers', {
          n: formatCount(p.followers)
        })) + " · " + _toDisplayString(_ctx.$t('nav.searchWinRate', {
          n: p.winRate
        })), 1)]), _createVNode(_component_el_icon, {
          class: "app-nav__search-item-arrow"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowRight))]),
          _: 1
        })], 8, _hoisted_20)]);
      }), 128))])), _createElementVNode("button", {
        type: "button",
        class: "app-nav__search-see-all",
        onClick: onSearch
      }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('nav.searchSeeAll', {
        q: trimmedSearch.value
      })), 1), _createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(ArrowRight))]),
        _: 1
      })])])) : _createCommentVNode("", true)], 512), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navChannelLinks.value, item => {
        return _openBlock(), _createBlock(_component_router_link, {
          key: item.key,
          to: item.to,
          custom: ""
        }, {
          default: _withCtx(({
            isActive,
            href,
            navigate
          }) => [_createElementVNode("a", {
            href: href,
            class: _normalizeClass(["app-nav__link app-nav__link--with-icon", {
              'router-link-active': isActive
            }]),
            onClick: $event => onNavChannelClick(item, navigate, $event)
          }, [_createElementVNode("span", _hoisted_28, [_createVNode(NavChannelIcon, {
            name: item.icon,
            active: isActive
          }, null, 8, ["name", "active"])]), _createTextVNode(" " + _toDisplayString(_ctx.$t(item.labelKey)), 1)], 10, _hoisted_27)]),
          _: 2
        }, 1032, ["to"]);
      }), 128))]), _createVNode(NavAppDownloadEntry, {
        class: "app-nav__app-download"
      })]), _createElementVNode("div", _hoisted_29, [_unref(authHydrating) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [!_unref(isMobileNav) ? (_openBlock(), _createElementBlock("div", _hoisted_30, [...(_cache[14] || (_cache[14] = [_createElementVNode("span", {
        class: "feed-skeleton-block app-nav__hydrate-balance"
      }, null, -1), _createElementVNode("span", {
        class: "feed-skeleton-block app-nav__hydrate-balance"
      }, null, -1)]))])) : _createCommentVNode("", true), !_unref(isMobileNav) ? (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[15] || (_cache[15] = [_createElementVNode("span", {
        class: "feed-skeleton-block app-nav__hydrate-btn"
      }, null, -1), _createElementVNode("span", {
        class: "feed-skeleton-block app-nav__hydrate-btn app-nav__hydrate-btn--wide"
      }, null, -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["app-nav__tools", {
          'app-nav__tools--h5-guest': _unref(isMobileNav)
        }]),
        "aria-busy": "true",
        "aria-hidden": "true"
      }, [_unref(isMobileNav) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_cache[16] || (_cache[16] = _createElementVNode("div", {
        class: "app-nav__auth app-nav__auth--h5 app-nav__hydrating"
      }, [_createElementVNode("span", {
        class: "feed-skeleton-block app-nav__hydrate-auth-link"
      }), _createElementVNode("span", {
        class: "feed-skeleton-block app-nav__hydrate-auth-btn"
      })], -1)), _cache[17] || (_cache[17] = _createElementVNode("span", {
        class: "feed-skeleton-block app-nav__hydrate-icon"
      }, null, -1))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_cache[18] || (_cache[18] = _createElementVNode("span", {
        class: "feed-skeleton-block app-nav__hydrate-icon"
      }, null, -1)), _cache[19] || (_cache[19] = _createElementVNode("span", {
        class: "feed-skeleton-block app-nav__hydrate-avatar"
      }, null, -1))], 64))], 2)], 64)) : !_unref(isLoggedIn) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [!_unref(isMobileNav) ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "app-nav__how-to-play",
        onClick: _cache[4] || (_cache[4] = $event => howToPlayOpen.value = true)
      }, [_createElementVNode("span", _hoisted_32, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
        _: 1
      })]), _createTextVNode(" " + _toDisplayString(_ctx.$t('nav.howToPlay')), 1)])) : _createCommentVNode("", true), !_unref(isMobileNav) ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createElementVNode("button", {
        type: "button",
        class: "app-nav__auth-link",
        onClick: openLoginDialog
      }, _toDisplayString(_ctx.$t('nav.login')), 1), _createVNode(_component_el_button, {
        class: "btn-register",
        onClick: openRegisterDialog
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('nav.register')), 1)]),
        _: 1
      })])) : _createCommentVNode("", true), !_unref(isMobileNav) ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createVNode(AppNavGuestMenu, {
        onSwitchLocale: switchLocale
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("button", {
        type: "button",
        class: "app-nav__auth-link app-nav__auth-link--h5",
        onClick: openLoginDialog
      }, _toDisplayString(_ctx.$t('nav.login')), 1), _createVNode(_component_el_button, {
        class: "btn-register btn-register--h5",
        onClick: openRegisterDialog
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('nav.register')), 1)]),
        _: 1
      })]), _createElementVNode("button", {
        type: "button",
        class: "app-nav__tool-icon-btn app-nav__tool-icon-btn--sm app-nav__support-btn",
        "aria-label": _ctx.$t('nav.customerService'),
        onClick: _withModifiers(openCustomerService, ["stop", "prevent"])
      }, [...(_cache[20] || (_cache[20] = [_createElementVNode("span", {
        class: "app-nav__more-dots",
        "aria-hidden": "true"
      }, [_createElementVNode("i"), _createElementVNode("i"), _createElementVNode("i")], -1)]))], 8, _hoisted_37)]))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [!_unref(isMobileNav) ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("button", {
        type: "button",
        class: "app-nav__balance",
        onClick: goAccount
      }, [_createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('nav.totalAssets')), 1), _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(navTotalAssetsLabel)), 1)]), _createElementVNode("button", {
        type: "button",
        class: "app-nav__balance",
        onClick: goAccount
      }, [_createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('nav.balance')), 1), _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(navWalletBalanceLabel)), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_43, [_unref(isLoggedIn) ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "btn-deposit",
        icon: _unref(WalletFilled),
        onClick: openDeposit
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('deposit.btnLabel')), 1)]),
        _: 1
      }, 8, ["icon"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_44, [_createVNode(_component_el_button, {
        class: "btn-create-market",
        icon: _unref(Plus),
        onClick: goCreateMarket
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('nav.createMarket')), 1)]),
        _: 1
      }, 8, ["icon"]), _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('nav.createMarketHint')), 1)]), showGetVantButton ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        class: "btn-get-vant",
        round: "",
        icon: _unref(Coin),
        onClick: goGetVant
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('nav.getVant')), 1)]),
        _: 1
      }, 8, ["icon"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_46, [_unref(isMobileNav) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_unref(isLoggedIn) ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "app-nav__balance-chip",
        "aria-label": `${_ctx.$t('nav.balance')} ${_unref(navWalletBalanceLabel)}`,
        onClick: goAccount
      }, [_createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t('nav.balance')), 1), _createElementVNode("span", _hoisted_49, _toDisplayString(_unref(navWalletBalanceLabel)), 1)], 8, _hoisted_47)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_50, [_createVNode(_component_el_badge, {
        "is-dot": _unref(hasUnread),
        class: "app-nav__notify-badge"
      }, {
        default: _withCtx(() => [_createElementVNode("button", {
          type: "button",
          class: "app-nav__tool-icon-btn app-nav__tool-icon-btn--sm",
          "aria-label": _ctx.$t('nav.notifications'),
          onClick: _withModifiers(goNotifications, ["stop"])
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Bell))]),
          _: 1
        })], 8, _hoisted_51)]),
        _: 1
      }, 8, ["is-dot"])]), _createElementVNode("button", {
        type: "button",
        class: "app-nav__tool-icon-btn app-nav__tool-icon-btn--sm app-nav__support-btn",
        "aria-label": _ctx.$t('nav.customerService'),
        onClick: _withModifiers(openCustomerService, ["stop", "prevent"])
      }, [...(_cache[21] || (_cache[21] = [_createElementVNode("span", {
        class: "app-nav__more-dots",
        "aria-hidden": "true"
      }, [_createElementVNode("i"), _createElementVNode("i"), _createElementVNode("i")], -1)]))], 8, _hoisted_52)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", {
        ref_key: "notifyWrapRef",
        ref: notifyWrapRef,
        class: "app-nav__notify-wrap"
      }, [_createVNode(_component_el_badge, {
        "is-dot": _unref(hasUnread),
        class: "app-nav__notify-badge"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          class: "app-nav__icon-btn app-nav__notify-btn",
          circle: "",
          "aria-label": _ctx.$t('nav.notifications'),
          "aria-expanded": notifyOpen.value,
          onClick: _withModifiers(onNotifyToggle, ["stop"])
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Bell))]),
            _: 1
          })]),
          _: 1
        }, 8, ["aria-label", "aria-expanded"])]),
        _: 1
      }, 8, ["is-dot"]), _createVNode(NotificationPanel, {
        modelValue: notifyOpen.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => notifyOpen.value = $event),
        onRead: _unref(refreshUnreadCounts)
      }, null, 8, ["modelValue", "onRead"])], 512), _createVNode(AppNavUserMenu, {
        profile: _unref(navProfile),
        "profile-loading": _unref(navProfileLoading),
        "logging-out": loggingOut.value,
        onLogout: onNavLogout,
        onSwitchLocale: switchLocale,
        onProfileUpdated: _unref(refreshNavSummary)
      }, null, 8, ["profile", "profile-loading", "logging-out", "onProfileUpdated"])], 64))])], 64))])]), showH5ChannelNav.value ? (_openBlock(), _createBlock(H5ChannelNav, {
        key: 0
      })) : _createCommentVNode("", true)])], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["app-main", {
          'app-main--fullscreen': isFullscreenRoute.value,
          'app-main--feed-scroll': isFeedScrollRoute.value
        }])
      }, [_createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component,
          route: viewRoute
        }) => [(_openBlock(), _createBlock(_KeepAlive, {
          max: 12
        }, [Component && viewRoute.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: keepAliveViewKey(viewRoute)
        })) : _createCommentVNode("", true)], 1024)), Component && !viewRoute.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: viewRoute.fullPath
        })) : _createCommentVNode("", true)]),
        _: 1
      })], 2), !isQuietShellRoute.value ? (_openBlock(), _createBlock(_unref(AuthDialog), {
        key: 1,
        modelValue: authDialogVisible.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => authDialogVisible.value = $event),
        "initial-tab": authInitialTab.value,
        "hide-wallet-options": authDialogHideWallets.value,
        "context-message-key": authDialogContextKey.value,
        "redirect-completing": googleRedirectCompleting.value,
        "redirect-signing-in": googleRedirectSigningIn.value
      }, null, 8, ["modelValue", "initial-tab", "hide-wallet-options", "context-message-key", "redirect-completing", "redirect-signing-in"])) : _createCommentVNode("", true), !isQuietShellRoute.value ? (_openBlock(), _createBlock(_unref(StorageBlockedFullscreen), {
        key: 2
      })) : _createCommentVNode("", true), !isQuietShellRoute.value ? (_openBlock(), _createBlock(_unref(DepositDialog), {
        key: 3,
        modelValue: showDeposit.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => showDeposit.value = $event),
        onDeposited: _unref(depositBonusPromptStore).markSuccessfulDeposit
      }, null, 8, ["modelValue", "onDeposited"])) : _createCommentVNode("", true), !isQuietShellRoute.value && _unref(depositBonusCampaignVisible) ? (_openBlock(), _createBlock(_unref(DepositBonusBenefitsDialog), {
        key: 4,
        "model-value": _unref(bonusBenefitsOpen),
        "current-usd": _unref(depositBonusLadderUsd),
        "onUpdate:modelValue": onBonusBenefitsVisible,
        onConfirm: onBonusBenefitsConfirm
      }, null, 8, ["model-value", "current-usd"])) : _createCommentVNode("", true), !isQuietShellRoute.value ? (_openBlock(), _createBlock(PmAlertDialog, {
        key: 5,
        "model-value": _unref(chinaRegionUnsupportedOpen),
        title: _unref(t)('deposit.chinaRegionUnsupportedTitle'),
        message: _unref(t)('deposit.chinaRegionUnsupportedBody'),
        "confirm-text": _unref(t)('deposit.chinaRegionUnsupportedConfirm'),
        "close-aria-label": _unref(t)('deposit.close'),
        "close-on-click-modal": true,
        "z-index": _unref(Z_INDEX).CHINA_REGION_ALERT,
        "onUpdate:modelValue": onChinaRegionUnsupportedVisible,
        onConfirm: _unref(dismissChinaRegionUnsupportedDialog)
      }, null, 8, ["model-value", "title", "message", "confirm-text", "close-aria-label", "z-index", "onConfirm"])) : _createCommentVNode("", true), !isQuietShellRoute.value ? (_openBlock(), _createBlock(PmAlertDialog, {
        key: 6,
        "model-value": _unref(trialActivateDepositPromptOpen),
        title: _unref(t)('trialFund.orderNeedDepositTitle'),
        message: _unref(t)('trialFund.orderNeedDepositMessage'),
        "confirm-text": _unref(t)('trialFund.orderNeedDepositConfirm'),
        "close-aria-label": _unref(t)('deposit.close'),
        "close-on-click-modal": true,
        "z-index": _unref(Z_INDEX).TRIAL_ACTIVATE_DEPOSIT_ALERT,
        "onUpdate:modelValue": onTrialActivateDepositVisible,
        onConfirm: onTrialActivateDepositConfirm
      }, null, 8, ["model-value", "title", "message", "confirm-text", "close-aria-label", "z-index"])) : _createCommentVNode("", true), !isQuietShellRoute.value ? (_openBlock(), _createBlock(PmAlertDialog, {
        key: 7,
        "model-value": _unref(mmWakeMatchingPromptOpen),
        title: _unref(t)('tradeDialog.orderMatchingHint'),
        "confirm-text": _unref(t)('markets.dialogOk'),
        "close-aria-label": _unref(t)('deposit.close'),
        "close-on-click-modal": true,
        "show-close": true,
        "z-index": _unref(Z_INDEX).MM_WAKE_MATCHING_ALERT,
        "onUpdate:modelValue": onMmWakeMatchingVisible,
        onConfirm: onMmWakeMatchingConfirm
      }, null, 8, ["model-value", "title", "confirm-text", "close-aria-label", "z-index"])) : _createCommentVNode("", true), !isQuietShellRoute.value ? (_openBlock(), _createBlock(_unref(DepositStatusEmbeddedPanel), {
        key: 8
      })) : _createCommentVNode("", true), !isQuietShellRoute.value ? (_openBlock(), _createBlock(_unref(AnchorHintHost), {
        key: 9
      })) : _createCommentVNode("", true), !isQuietShellRoute.value ? (_openBlock(), _createBlock(_unref(CreditClaimToastHost), {
        key: 10
      })) : _createCommentVNode("", true), !isQuietShellRoute.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 11
      }, [!_unref(trialGuideBlocksPrompts) ? (_openBlock(), _createBlock(_unref(TradeApprovalDialog), {
        key: 0
      })) : _createCommentVNode("", true), _createVNode(_unref(EnableTradingDialog), {
        "model-value": _unref(enableTradingOpen) && !_unref(trialGuideBlocksPrompts),
        "market-kind": _unref(enableTradingMarketKind),
        "approval-ready": _unref(enableTradingApprovalReady),
        "onUpdate:modelValue": _unref(setEnableTradingOpen),
        onCompleted: _unref(completeEnableTradingPrompt)
      }, null, 8, ["model-value", "market-kind", "approval-ready", "onUpdate:modelValue", "onCompleted"]), _createVNode(_unref(RegisterRewardGuestDialog), {
        "model-value": _unref(guestModalOpen) && !_unref(trialGuideBlocksPrompts) && !authDialogVisible.value,
        onLogin: onRegisterRewardGuestLogin,
        onMinimize: onRegisterRewardGuestMinimize
      }, null, 8, ["model-value"]), _createVNode(_unref(TrialFundGuestDialog), {
        "model-value": _unref(trialGuestModalOpen) && !_unref(trialGuideBlocksPrompts),
        onLogin: onTrialFundGuestLogin,
        onLater: onTrialFundGuestLater
      }, null, 8, ["model-value"]), _createVNode(_unref(TrialFundLoggedDialog), {
        "model-value": _unref(trialLoggedModalOpen) && !_unref(trialGuideBlocksPrompts),
        onClaim: onTrialFundGoClaim,
        onViewDscoin: onTrialFundViewDscoin,
        onLater: onTrialFundLoggedLater
      }, null, 8, ["model-value"]), _createVNode(_unref(TrialFundLoggedMini), {
        "model-value": (_unref(trialGuestMiniOpen) || _unref(trialLoggedMiniOpen)) && !authDialogVisible.value && !_unref(trialGuideBlocksPrompts) && _unref(route).name !== _unref(TRIAL_FUND_SIM_ROUTE_NAME) && !String(_unref(route).path || '').startsWith('/trial-fund'),
        onExpand: onTrialFundMiniExpand
      }, null, 8, ["model-value"]), _createVNode(_unref(TrialFundResultDialog), {
        "model-value": _unref(trialResultOpen) && (!_unref(trialGuideBlocksPrompts) || _unref(trialGuidePausedForResult)),
        kind: _unref(trialResultKind) || 'win',
        "chosen-side": _unref(trialResultChosenSide) || 'no',
        "dusd-balance": _unref(trialDusdBalance),
        "claim-loading": _unref(trialClaimLoading),
        "claim-hint": _unref(trialSurfaceHint),
        "claim-hint-tone": _unref(trialSurfaceHintTone),
        "mint-status": _unref(trialClaimMintStatus),
        "show-deposit-cta": _unref(trialClaimNeedsDeposit),
        "onUpdate:modelValue": onTrialResultVisible,
        onViewBalance: onTrialResultViewBalance,
        onContinue: onTrialResultContinue,
        onRetry: onTrialResultRetry,
        onDeposit: onTrialResultDeposit,
        onClearClaimHint: _cache[8] || (_cache[8] = $event => _unref(trialFundStore).clearSurfaceHint())
      }, null, 8, ["model-value", "kind", "chosen-side", "dusd-balance", "claim-loading", "claim-hint", "claim-hint-tone", "mint-status", "show-deposit-cta"]), _unref(isMobileNav) && !isFullscreenRoute.value && !isQuietShellRoute.value && !_unref(trialGuideBlocksPrompts) ? (_openBlock(), _createBlock(H5HowToPlayBanner, {
        key: 1,
        onOpen: _cache[9] || (_cache[9] = $event => howToPlayOpen.value = true)
      })) : _createCommentVNode("", true), !hidePwaBanner.value && !isQuietShellRoute.value && !_unref(trialGuideBlocksPrompts) ? (_openBlock(), _createBlock(_unref(PwaInstallBanner), {
        key: 2,
        class: _normalizeClass({
          'pwa-install-banner--above-tab': !isFullscreenRoute.value
        })
      }, null, 8, ["class"])) : _createCommentVNode("", true), _createVNode(_unref(PortraitLockOverlay))], 64)) : _createCommentVNode("", true), !isFullscreenRoute.value ? (_openBlock(), _createBlock(MobileTabBar, {
        key: 12,
        "mine-open": isProfileRouteActive.value,
        onOpenMine: onH5AvatarOrMineClick,
        onNavigate: closeNavSearch,
        onCreate: goCreateMarket
      }, null, 8, ["mine-open"])) : _createCommentVNode("", true), _createVNode(_component_el_drawer, {
        modelValue: mobileMenuOpen.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => mobileMenuOpen.value = $event),
        direction: "ltr",
        size: "min(320px, 88vw)",
        "show-close": true,
        title: _ctx.$t('nav.mobileMoreTitle'),
        class: "app-mobile-more-drawer",
        "append-to-body": "",
        "z-index": _unref(Z_INDEX).MOBILE_NAV_DRAWER
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("section", _hoisted_55, [_createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.$t('siteFooter.legalNav')), 1), _createElementVNode("nav", {
          class: "app-mobile-more__menu",
          "aria-label": _ctx.$t('siteFooter.legalNav')
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mobileMoreLegalLinks), link => {
          return _openBlock(), _createElementBlock("button", {
            key: link.to,
            type: "button",
            class: "app-mobile-more__menu-item app-mobile-more__menu-item--plain",
            onClick: $event => onMobileMoreNav(link.to)
          }, [_createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t(link.labelKey)), 1)], 8, _hoisted_58);
        }), 128))], 8, _hoisted_57)]), _createElementVNode("section", _hoisted_60, [_createElementVNode("p", _hoisted_61, _toDisplayString(_ctx.$t('helpPage.contact.sectionTitle')), 1), _createElementVNode("nav", {
          class: "app-mobile-more__menu",
          "aria-label": _ctx.$t('helpPage.contact.sectionTitle')
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mobileMoreSupportExternalLinks), link => {
          return _openBlock(), _createElementBlock("a", {
            key: link.key || link.labelKey,
            class: "app-mobile-more__menu-item app-mobile-more__menu-item--plain app-mobile-more__menu-link",
            href: link.openTawk ? '#' : link.href,
            target: link.openTawk ? undefined : '_blank',
            rel: link.openTawk ? undefined : 'noopener noreferrer',
            onClick: $event => onMobileMoreExternalSupportClick($event, link)
          }, [_createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.$t(link.labelKey)), 1)], 8, _hoisted_63);
        }), 128)), _createElementVNode("div", _hoisted_65, [_createElementVNode("a", {
          class: "app-mobile-more__support-main app-mobile-more__menu-link",
          href: _unref(mobileMoreSupportEmail).href,
          onClick: onMobileMoreSupportClick
        }, [_createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.$t(_unref(mobileMoreSupportEmail).labelKey)), 1), _createElementVNode("span", _hoisted_68, _toDisplayString(_unref(mobileMoreSupportEmail).address), 1)], 8, _hoisted_66), _createElementVNode("button", {
          type: "button",
          class: "app-mobile-more__copy-btn",
          "aria-label": _ctx.$t('helpPage.contact.email.title'),
          onClick: _cache[10] || (_cache[10] = _withModifiers($event => copyMobileMoreEmail($event), ["stop"]))
        }, [_createVNode(_component_el_icon, {
          "aria-hidden": "true"
        }, {
          default: _withCtx(() => [_createVNode(_unref(DocumentCopy))]),
          _: 1
        })], 8, _hoisted_69)])], 8, _hoisted_62)]), _createElementVNode("section", _hoisted_70, [_createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.$t('nav.selectLanguage')), 1), _createElementVNode("nav", {
          class: "app-mobile-more__menu",
          "aria-label": _ctx.$t('nav.selectLanguage')
        }, [_createElementVNode("button", {
          type: "button",
          class: "app-mobile-more__menu-item app-mobile-more__menu-item--plain",
          onClick: openMobileMoreLocale
        }, [_createElementVNode("span", _hoisted_73, _toDisplayString(mobileMoreLocaleOption.value.flag), 1), _createElementVNode("span", _hoisted_74, _toDisplayString(mobileMoreLocaleOption.value.label), 1), _createVNode(_component_el_icon, {
          class: "app-mobile-more__locale-chevron",
          "aria-hidden": "true"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowRight))]),
          _: 1
        })])], 8, _hoisted_72)])]), _createElementVNode("footer", _hoisted_75, [_createElementVNode("div", _hoisted_76, [!_unref(isLoggedIn) ? (_openBlock(), _createElementBlock("div", _hoisted_77, [_createElementVNode("button", {
          type: "button",
          class: "app-mobile-more__auth-login",
          onClick: openMobileMoreLogin
        }, _toDisplayString(_ctx.$t('nav.login')), 1), _createVNode(_component_el_button, {
          class: "btn-register app-mobile-more__auth-register",
          round: "",
          onClick: openMobileMoreRegister
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('nav.register')), 1)]),
          _: 1
        })])) : (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "app-mobile-more__auth-logout",
          disabled: loggingOut.value,
          "aria-busy": loggingOut.value ? 'true' : undefined,
          onClick: onMobileMoreLogout
        }, _toDisplayString(loggingOut.value ? _ctx.$t('nav.loggingOut') : _ctx.$t('nav.logout')), 9, _hoisted_78))]), _createElementVNode("p", _hoisted_79, _toDisplayString(_ctx.$t('siteFooter.copyright', {
          year: _unref(mobileMoreCopyrightYear)
        })), 1)])])]),
        _: 1
      }, 8, ["modelValue", "title", "z-index"]), _createVNode(H5LocaleSheet, {
        modelValue: localeSheetOpen.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => localeSheetOpen.value = $event),
        onSwitchLocale: onMobileMoreSwitchLocale
      }, null, 8, ["modelValue"]), !isQuietShellRoute.value && !_unref(trialGuideBlocksPrompts) ? (_openBlock(), _createBlock(HowToPlayTour, {
        key: 13,
        modelValue: howToPlayOpen.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => howToPlayOpen.value = $event),
        onGetStarted: onHowToPlayGetStarted
      }, null, 8, ["modelValue"])) : _createCommentVNode("", true), !isFullscreenRoute.value && !isQuietShellRoute.value && showFloatingAssistantDuringGuide.value ? (_openBlock(), _createBlock(FloatingAssistantFab, {
        key: 14,
        mobile: _unref(isMobileNav)
      }, null, 8, ["mobile"])) : _createCommentVNode("", true), _createVNode(TrialFundGuideHost), _unref(jackpotFeatureEnabled) && !isQuietShellRoute.value ? (_openBlock(), _createBlock(JackpotSyncBanner, {
        key: 15
      })) : _createCommentVNode("", true)], 2);
    };
  }
};